import { ContentAndImage } from 'app/components/layouts';
import { CreateAccountPage } from 'app/pages/CreateAccountPage';
import { ForgotPasswordPage } from 'app/pages/ForgotPasswordPage';
import { LoginPage } from 'app/pages/LogInPage';
import { LoginHeader } from 'app/pages/LogInPage/LogInHeader';
import ForgotPassImgJpg from 'assets/images/account/img_auth_forgotpass.jpg';
import ForgotPassImgWebp from 'assets/images/account/img_auth_forgotpass.webp';
import LoginImgJpg from 'assets/images/account/img_auth_login.jpg';
import LoginImgWebp from 'assets/images/account/img_auth_login.webp';
import RegisterImgJpg from 'assets/images/account/img_auth_register.jpg';
import RegisterImgWebp from 'assets/images/account/img_auth_register.webp';
import React from 'react';
import { Route } from 'react-router-dom';

export default function PublicRoutes() {
  return (
    <>
      <Route
        path="/forgotPassword"
        element={
          <ContentAndImage
            header={<LoginHeader />}
            webpImage={ForgotPassImgWebp}
            jpgImage={ForgotPassImgJpg}
          >
            <ForgotPasswordPage />
          </ContentAndImage>
        }
      />

      <Route
        path="/createAccount"
        element={
          <ContentAndImage
            header={<LoginHeader />}
            webpImage={RegisterImgWebp}
            jpgImage={RegisterImgJpg}
          >
            <CreateAccountPage />
          </ContentAndImage>
        }
      />

      <Route
        path="/login"
        element={
          <ContentAndImage
            header={<LoginHeader />}
            webpImage={LoginImgWebp}
            jpgImage={LoginImgJpg}
          >
            <LoginPage />
          </ContentAndImage>
        }
      />
    </>
  );
}
